// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"cb6433cb","192":"6d5ff71a","250":"8ae136da","253":"1e484a08","427":"9311a64d","447":"cd55cdf0","634":"720303d5","812":"f586ee37","959":"4a03a5e4"}[chunkId] + ".chunk.js";
};